/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutAnalyzerInsightsRouteRouteImport } from './routes/_layout/analyzer-insights/route'
import { Route as LayoutAnnouncementsRouteRouteImport } from './routes/_layout/announcements/route'
import { Route as LayoutBrevoRouteRouteImport } from './routes/_layout/brevo/route'
import { Route as LayoutFeedbackFormsRouteRouteImport } from './routes/_layout/feedback-forms/route'
import { Route as LayoutSpotOfTheWeekRouteRouteImport } from './routes/_layout/spot-of-the-week/route'
import { Route as LayoutAnalyzerInsightsIndexRouteImport } from './routes/_layout/analyzer-insights/index'
import { Route as LayoutAnalyzerInsightsHelpRouteRouteImport } from './routes/_layout/analyzer-insights/help/route'
import { Route as LayoutAnalyzerInsightsQuotaRouteRouteImport } from './routes/_layout/analyzer-insights/quota/route'
import { Route as LayoutAnalyzerInsightsRoomsRouteRouteImport } from './routes/_layout/analyzer-insights/rooms/route'
import { Route as LayoutAnalyzerInsightsSpotsRouteRouteImport } from './routes/_layout/analyzer-insights/spots/route'
import { Route as LayoutAnalyzerInsightsUsersRouteRouteImport } from './routes/_layout/analyzer-insights/users/route'
import { Route as LayoutAnnouncementsIndexRouteImport } from './routes/_layout/announcements/index'
import { Route as LayoutAnnouncementsAnnouncementIdRouteRouteImport } from './routes/_layout/announcements/$announcementId/route'
import { Route as LayoutAnnouncementsHelpRouteRouteImport } from './routes/_layout/announcements/help/route'
import { Route as LayoutAnnouncementsLogsRouteRouteImport } from './routes/_layout/announcements/logs/route'
import { Route as LayoutAnnouncementsNewRouteRouteImport } from './routes/_layout/announcements/new/route'
import { Route as LayoutBrevoIndexRouteImport } from './routes/_layout/brevo/index'
import { Route as LayoutBrevoAutomationsRouteRouteImport } from './routes/_layout/brevo/automations/route'
import { Route as LayoutBrevoContactsRouteRouteImport } from './routes/_layout/brevo/contacts/route'
import { Route as LayoutBrevoDeliveryLogRouteRouteImport } from './routes/_layout/brevo/delivery-log/route'
import { Route as LayoutBrevoEventsRouteRouteImport } from './routes/_layout/brevo/events/route'
import { Route as LayoutBrevoHelpRouteRouteImport } from './routes/_layout/brevo/help/route'
import { Route as LayoutBrevoInsightsRouteRouteImport } from './routes/_layout/brevo/insights/route'
import { Route as LayoutBrevoRevenueRouteRouteImport } from './routes/_layout/brevo/revenue/route'
import { Route as LayoutBrevoSettingsRouteRouteImport } from './routes/_layout/brevo/settings/route'
import { Route as LayoutFeedbackFormsIndexRouteImport } from './routes/_layout/feedback-forms/index'
import { Route as LayoutFeedbackFormsFormIdRouteRouteImport } from './routes/_layout/feedback-forms/$formId/route'
import { Route as LayoutFeedbackFormsHelpRouteRouteImport } from './routes/_layout/feedback-forms/help/route'
import { Route as LayoutFeedbackFormsNewRouteRouteImport } from './routes/_layout/feedback-forms/new/route'
import { Route as LayoutInsiderFeaturesRouteRouteImport } from './routes/_layout/insider/features/route'
import { Route as LayoutInsiderHelpRouteRouteImport } from './routes/_layout/insider/help/route'
import { Route as LayoutInsiderMembersRouteRouteImport } from './routes/_layout/insider/members/route'
import { Route as LayoutPloSolutionUploadGamemodesRouteRouteImport } from './routes/_layout/plo-solution-upload/gamemodes/route'
import { Route as LayoutPloSolutionUploadGametypesRouteRouteImport } from './routes/_layout/plo-solution-upload/gametypes/route'
import { Route as LayoutPloSolutionUploadHelpRouteRouteImport } from './routes/_layout/plo-solution-upload/help/route'
import { Route as LayoutPloSolutionUploadUploadJobsRouteRouteImport } from './routes/_layout/plo-solution-upload/upload-jobs/route'
import { Route as LayoutSpotOfTheWeekIndexRouteImport } from './routes/_layout/spot-of-the-week/index'
import { Route as LayoutSpotOfTheWeekWeekIdRouteRouteImport } from './routes/_layout/spot-of-the-week/$weekId/route'
import { Route as LayoutSpotOfTheWeekHelpRouteRouteImport } from './routes/_layout/spot-of-the-week/help/route'
import { Route as LoginOauthIndexRouteImport } from './routes/login/oauth/index'
import { Route as LayoutBrevoAutomationsIndexRouteImport } from './routes/_layout/brevo/automations/index'
import { Route as LayoutBrevoAutomationsChurnWinbackRouteRouteImport } from './routes/_layout/brevo/automations/churn-winback/route'
import { Route as LayoutBrevoEventsIndexRouteImport } from './routes/_layout/brevo/events/index'
import { Route as LayoutBrevoEventsNewRouteRouteImport } from './routes/_layout/brevo/events/new/route'
import { Route as LayoutBrevoRevenueIndexRouteImport } from './routes/_layout/brevo/revenue/index'
import { Route as LayoutBrevoRevenueIdRouteRouteImport } from './routes/_layout/brevo/revenue/$id/route'
import { Route as LayoutBrevoRevenueCompareRouteRouteImport } from './routes/_layout/brevo/revenue/compare/route'
import { Route as LayoutFeedbackFormsFormIdIndexRouteImport } from './routes/_layout/feedback-forms/$formId/index'
import { Route as LayoutFeedbackFormsFormIdResultsRouteRouteImport } from './routes/_layout/feedback-forms/$formId/results/route'
import { Route as LayoutInsiderFeaturesIndexRouteImport } from './routes/_layout/insider/features/index'
import { Route as LayoutInsiderFeaturesFlagIdRouteRouteImport } from './routes/_layout/insider/features/$flagId/route'
import { Route as LayoutInsiderMembersIndexRouteImport } from './routes/_layout/insider/members/index'
import { Route as LayoutInsiderMembersMemberIdRouteRouteImport } from './routes/_layout/insider/members/$memberId/route'
import { Route as LayoutPloSolutionUploadGamemodesIndexRouteImport } from './routes/_layout/plo-solution-upload/gamemodes/index'
import { Route as LayoutPloSolutionUploadGamemodesIdRouteRouteImport } from './routes/_layout/plo-solution-upload/gamemodes/$id/route'
import { Route as LayoutBrevoEventsIdEditRouteRouteImport } from './routes/_layout/brevo/events/$id/edit/route'
import { Route as LayoutBrevoEventsIdTestFireRouteRouteImport } from './routes/_layout/brevo/events/$id/test-fire/route'
import { Route as LayoutPloSolutionUploadGamemodesIdIndexRouteImport } from './routes/_layout/plo-solution-upload/gamemodes/$id/index'
import { Route as LayoutPloSolutionUploadGamemodesIdUploadRouteRouteImport } from './routes/_layout/plo-solution-upload/gamemodes/$id/upload/route'

const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAnalyzerInsightsRouteRoute =
  LayoutAnalyzerInsightsRouteRouteImport.update({
    id: '/analyzer-insights',
    path: '/analyzer-insights',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAnnouncementsRouteRoute =
  LayoutAnnouncementsRouteRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/announcements/route.lazy').then((d) => d.Route),
  )
const LayoutBrevoRouteRoute = LayoutBrevoRouteRouteImport.update({
  id: '/brevo',
  path: '/brevo',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/brevo/route.lazy').then((d) => d.Route),
)
const LayoutFeedbackFormsRouteRoute =
  LayoutFeedbackFormsRouteRouteImport.update({
    id: '/feedback-forms',
    path: '/feedback-forms',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/feedback-forms/route.lazy').then((d) => d.Route),
  )
const LayoutSpotOfTheWeekRouteRoute =
  LayoutSpotOfTheWeekRouteRouteImport.update({
    id: '/spot-of-the-week',
    path: '/spot-of-the-week',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/spot-of-the-week/route.lazy').then((d) => d.Route),
  )
const LayoutAnalyzerInsightsIndexRoute =
  LayoutAnalyzerInsightsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutAnalyzerInsightsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/analyzer-insights/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnalyzerInsightsHelpRouteRoute =
  LayoutAnalyzerInsightsHelpRouteRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => LayoutAnalyzerInsightsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/analyzer-insights/help/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnalyzerInsightsQuotaRouteRoute =
  LayoutAnalyzerInsightsQuotaRouteRouteImport.update({
    id: '/quota',
    path: '/quota',
    getParentRoute: () => LayoutAnalyzerInsightsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/analyzer-insights/quota/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnalyzerInsightsRoomsRouteRoute =
  LayoutAnalyzerInsightsRoomsRouteRouteImport.update({
    id: '/rooms',
    path: '/rooms',
    getParentRoute: () => LayoutAnalyzerInsightsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/analyzer-insights/rooms/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnalyzerInsightsSpotsRouteRoute =
  LayoutAnalyzerInsightsSpotsRouteRouteImport.update({
    id: '/spots',
    path: '/spots',
    getParentRoute: () => LayoutAnalyzerInsightsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/analyzer-insights/spots/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnalyzerInsightsUsersRouteRoute =
  LayoutAnalyzerInsightsUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => LayoutAnalyzerInsightsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/analyzer-insights/users/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnnouncementsIndexRoute =
  LayoutAnnouncementsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutAnnouncementsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/announcements/index.lazy').then((d) => d.Route),
  )
const LayoutAnnouncementsAnnouncementIdRouteRoute =
  LayoutAnnouncementsAnnouncementIdRouteRouteImport.update({
    id: '/$announcementId',
    path: '/$announcementId',
    getParentRoute: () => LayoutAnnouncementsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/announcements/$announcementId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnnouncementsHelpRouteRoute =
  LayoutAnnouncementsHelpRouteRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => LayoutAnnouncementsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/announcements/help/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnnouncementsLogsRouteRoute =
  LayoutAnnouncementsLogsRouteRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => LayoutAnnouncementsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/announcements/logs/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutAnnouncementsNewRouteRoute =
  LayoutAnnouncementsNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => LayoutAnnouncementsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/announcements/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutBrevoIndexRoute = LayoutBrevoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutBrevoRouteRoute,
} as any)
const LayoutBrevoAutomationsRouteRoute =
  LayoutBrevoAutomationsRouteRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => LayoutBrevoRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/automations/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutBrevoContactsRouteRoute =
  LayoutBrevoContactsRouteRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => LayoutBrevoRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/contacts/route.lazy').then((d) => d.Route),
  )
const LayoutBrevoDeliveryLogRouteRoute =
  LayoutBrevoDeliveryLogRouteRouteImport.update({
    id: '/delivery-log',
    path: '/delivery-log',
    getParentRoute: () => LayoutBrevoRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/delivery-log/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutBrevoEventsRouteRoute = LayoutBrevoEventsRouteRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => LayoutBrevoRouteRoute,
} as any).lazy(() =>
  import('./routes/_layout/brevo/events/route.lazy').then((d) => d.Route),
)
const LayoutBrevoHelpRouteRoute = LayoutBrevoHelpRouteRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => LayoutBrevoRouteRoute,
} as any).lazy(() =>
  import('./routes/_layout/brevo/help/route.lazy').then((d) => d.Route),
)
const LayoutBrevoInsightsRouteRoute =
  LayoutBrevoInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => LayoutBrevoRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/insights/route.lazy').then((d) => d.Route),
  )
const LayoutBrevoRevenueRouteRoute = LayoutBrevoRevenueRouteRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => LayoutBrevoRouteRoute,
} as any)
const LayoutBrevoSettingsRouteRoute =
  LayoutBrevoSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LayoutBrevoRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/settings/route.lazy').then((d) => d.Route),
  )
const LayoutFeedbackFormsIndexRoute =
  LayoutFeedbackFormsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutFeedbackFormsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/feedback-forms/index.lazy').then((d) => d.Route),
  )
const LayoutFeedbackFormsFormIdRouteRoute =
  LayoutFeedbackFormsFormIdRouteRouteImport.update({
    id: '/$formId',
    path: '/$formId',
    getParentRoute: () => LayoutFeedbackFormsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/feedback-forms/$formId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutFeedbackFormsHelpRouteRoute =
  LayoutFeedbackFormsHelpRouteRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => LayoutFeedbackFormsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/feedback-forms/help/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutFeedbackFormsNewRouteRoute =
  LayoutFeedbackFormsNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => LayoutFeedbackFormsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/feedback-forms/new/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutInsiderFeaturesRouteRoute =
  LayoutInsiderFeaturesRouteRouteImport.update({
    id: '/insider/features',
    path: '/insider/features',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/insider/features/route.lazy').then((d) => d.Route),
  )
const LayoutInsiderHelpRouteRoute = LayoutInsiderHelpRouteRouteImport.update({
  id: '/insider/help',
  path: '/insider/help',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/insider/help/route.lazy').then((d) => d.Route),
)
const LayoutInsiderMembersRouteRoute =
  LayoutInsiderMembersRouteRouteImport.update({
    id: '/insider/members',
    path: '/insider/members',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/insider/members/route.lazy').then((d) => d.Route),
  )
const LayoutPloSolutionUploadGamemodesRouteRoute =
  LayoutPloSolutionUploadGamemodesRouteRouteImport.update({
    id: '/plo-solution-upload/gamemodes',
    path: '/plo-solution-upload/gamemodes',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/plo-solution-upload/gamemodes/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPloSolutionUploadGametypesRouteRoute =
  LayoutPloSolutionUploadGametypesRouteRouteImport.update({
    id: '/plo-solution-upload/gametypes',
    path: '/plo-solution-upload/gametypes',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/plo-solution-upload/gametypes/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPloSolutionUploadHelpRouteRoute =
  LayoutPloSolutionUploadHelpRouteRouteImport.update({
    id: '/plo-solution-upload/help',
    path: '/plo-solution-upload/help',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/plo-solution-upload/help/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPloSolutionUploadUploadJobsRouteRoute =
  LayoutPloSolutionUploadUploadJobsRouteRouteImport.update({
    id: '/plo-solution-upload/upload-jobs',
    path: '/plo-solution-upload/upload-jobs',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/plo-solution-upload/upload-jobs/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutSpotOfTheWeekIndexRoute =
  LayoutSpotOfTheWeekIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutSpotOfTheWeekRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/spot-of-the-week/index.lazy').then((d) => d.Route),
  )
const LayoutSpotOfTheWeekWeekIdRouteRoute =
  LayoutSpotOfTheWeekWeekIdRouteRouteImport.update({
    id: '/$weekId',
    path: '/$weekId',
    getParentRoute: () => LayoutSpotOfTheWeekRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/spot-of-the-week/$weekId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutSpotOfTheWeekHelpRouteRoute =
  LayoutSpotOfTheWeekHelpRouteRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => LayoutSpotOfTheWeekRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/spot-of-the-week/help/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LoginOauthIndexRoute = LoginOauthIndexRouteImport.update({
  id: '/oauth/',
  path: '/oauth/',
  getParentRoute: () => LoginRoute,
} as any)
const LayoutBrevoAutomationsIndexRoute =
  LayoutBrevoAutomationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutBrevoAutomationsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/automations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutBrevoAutomationsChurnWinbackRouteRoute =
  LayoutBrevoAutomationsChurnWinbackRouteRouteImport.update({
    id: '/churn-winback',
    path: '/churn-winback',
    getParentRoute: () => LayoutBrevoAutomationsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/automations/churn-winback/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutBrevoEventsIndexRoute = LayoutBrevoEventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutBrevoEventsRouteRoute,
} as any).lazy(() =>
  import('./routes/_layout/brevo/events/index.lazy').then((d) => d.Route),
)
const LayoutBrevoEventsNewRouteRoute =
  LayoutBrevoEventsNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => LayoutBrevoEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/events/new/route.lazy').then((d) => d.Route),
  )
const LayoutBrevoRevenueIndexRoute = LayoutBrevoRevenueIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutBrevoRevenueRouteRoute,
} as any).lazy(() =>
  import('./routes/_layout/brevo/revenue/index.lazy').then((d) => d.Route),
)
const LayoutBrevoRevenueIdRouteRoute =
  LayoutBrevoRevenueIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => LayoutBrevoRevenueRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/revenue/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutBrevoRevenueCompareRouteRoute =
  LayoutBrevoRevenueCompareRouteRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => LayoutBrevoRevenueRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/revenue/compare/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutFeedbackFormsFormIdIndexRoute =
  LayoutFeedbackFormsFormIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutFeedbackFormsFormIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/feedback-forms/$formId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutFeedbackFormsFormIdResultsRouteRoute =
  LayoutFeedbackFormsFormIdResultsRouteRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => LayoutFeedbackFormsFormIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/feedback-forms/$formId/results/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutInsiderFeaturesIndexRoute =
  LayoutInsiderFeaturesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutInsiderFeaturesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/insider/features/index.lazy').then((d) => d.Route),
  )
const LayoutInsiderFeaturesFlagIdRouteRoute =
  LayoutInsiderFeaturesFlagIdRouteRouteImport.update({
    id: '/$flagId',
    path: '/$flagId',
    getParentRoute: () => LayoutInsiderFeaturesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/insider/features/$flagId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutInsiderMembersIndexRoute =
  LayoutInsiderMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutInsiderMembersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/insider/members/index.lazy').then((d) => d.Route),
  )
const LayoutInsiderMembersMemberIdRouteRoute =
  LayoutInsiderMembersMemberIdRouteRouteImport.update({
    id: '/$memberId',
    path: '/$memberId',
    getParentRoute: () => LayoutInsiderMembersRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/insider/members/$memberId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPloSolutionUploadGamemodesIndexRoute =
  LayoutPloSolutionUploadGamemodesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutPloSolutionUploadGamemodesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/plo-solution-upload/gamemodes/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPloSolutionUploadGamemodesIdRouteRoute =
  LayoutPloSolutionUploadGamemodesIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => LayoutPloSolutionUploadGamemodesRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/plo-solution-upload/gamemodes/$id/route.lazy'
    ).then((d) => d.Route),
  )
const LayoutBrevoEventsIdEditRouteRoute =
  LayoutBrevoEventsIdEditRouteRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => LayoutBrevoEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/events/$id/edit/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutBrevoEventsIdTestFireRouteRoute =
  LayoutBrevoEventsIdTestFireRouteRouteImport.update({
    id: '/$id/test-fire',
    path: '/$id/test-fire',
    getParentRoute: () => LayoutBrevoEventsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_layout/brevo/events/$id/test-fire/route.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPloSolutionUploadGamemodesIdIndexRoute =
  LayoutPloSolutionUploadGamemodesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutPloSolutionUploadGamemodesIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/plo-solution-upload/gamemodes/$id/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutPloSolutionUploadGamemodesIdUploadRouteRoute =
  LayoutPloSolutionUploadGamemodesIdUploadRouteRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => LayoutPloSolutionUploadGamemodesIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/plo-solution-upload/gamemodes/$id/upload/route.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRouteWithChildren
  '/analyzer-insights': typeof LayoutAnalyzerInsightsRouteRouteWithChildren
  '/announcements': typeof LayoutAnnouncementsRouteRouteWithChildren
  '/brevo': typeof LayoutBrevoRouteRouteWithChildren
  '/feedback-forms': typeof LayoutFeedbackFormsRouteRouteWithChildren
  '/spot-of-the-week': typeof LayoutSpotOfTheWeekRouteRouteWithChildren
  '/analyzer-insights/help': typeof LayoutAnalyzerInsightsHelpRouteRoute
  '/analyzer-insights/quota': typeof LayoutAnalyzerInsightsQuotaRouteRoute
  '/analyzer-insights/rooms': typeof LayoutAnalyzerInsightsRoomsRouteRoute
  '/analyzer-insights/spots': typeof LayoutAnalyzerInsightsSpotsRouteRoute
  '/analyzer-insights/users': typeof LayoutAnalyzerInsightsUsersRouteRoute
  '/announcements/$announcementId': typeof LayoutAnnouncementsAnnouncementIdRouteRoute
  '/announcements/help': typeof LayoutAnnouncementsHelpRouteRoute
  '/announcements/logs': typeof LayoutAnnouncementsLogsRouteRoute
  '/announcements/new': typeof LayoutAnnouncementsNewRouteRoute
  '/brevo/automations': typeof LayoutBrevoAutomationsRouteRouteWithChildren
  '/brevo/contacts': typeof LayoutBrevoContactsRouteRoute
  '/brevo/delivery-log': typeof LayoutBrevoDeliveryLogRouteRoute
  '/brevo/events': typeof LayoutBrevoEventsRouteRouteWithChildren
  '/brevo/help': typeof LayoutBrevoHelpRouteRoute
  '/brevo/insights': typeof LayoutBrevoInsightsRouteRoute
  '/brevo/revenue': typeof LayoutBrevoRevenueRouteRouteWithChildren
  '/brevo/settings': typeof LayoutBrevoSettingsRouteRoute
  '/feedback-forms/$formId': typeof LayoutFeedbackFormsFormIdRouteRouteWithChildren
  '/feedback-forms/help': typeof LayoutFeedbackFormsHelpRouteRoute
  '/feedback-forms/new': typeof LayoutFeedbackFormsNewRouteRoute
  '/insider/features': typeof LayoutInsiderFeaturesRouteRouteWithChildren
  '/insider/help': typeof LayoutInsiderHelpRouteRoute
  '/insider/members': typeof LayoutInsiderMembersRouteRouteWithChildren
  '/plo-solution-upload/gamemodes': typeof LayoutPloSolutionUploadGamemodesRouteRouteWithChildren
  '/plo-solution-upload/gametypes': typeof LayoutPloSolutionUploadGametypesRouteRoute
  '/plo-solution-upload/help': typeof LayoutPloSolutionUploadHelpRouteRoute
  '/plo-solution-upload/upload-jobs': typeof LayoutPloSolutionUploadUploadJobsRouteRoute
  '/spot-of-the-week/$weekId': typeof LayoutSpotOfTheWeekWeekIdRouteRoute
  '/spot-of-the-week/help': typeof LayoutSpotOfTheWeekHelpRouteRoute
  '/analyzer-insights/': typeof LayoutAnalyzerInsightsIndexRoute
  '/announcements/': typeof LayoutAnnouncementsIndexRoute
  '/brevo/': typeof LayoutBrevoIndexRoute
  '/feedback-forms/': typeof LayoutFeedbackFormsIndexRoute
  '/spot-of-the-week/': typeof LayoutSpotOfTheWeekIndexRoute
  '/login/oauth/': typeof LoginOauthIndexRoute
  '/brevo/automations/churn-winback': typeof LayoutBrevoAutomationsChurnWinbackRouteRoute
  '/brevo/events/new': typeof LayoutBrevoEventsNewRouteRoute
  '/brevo/revenue/$id': typeof LayoutBrevoRevenueIdRouteRoute
  '/brevo/revenue/compare': typeof LayoutBrevoRevenueCompareRouteRoute
  '/feedback-forms/$formId/results': typeof LayoutFeedbackFormsFormIdResultsRouteRoute
  '/insider/features/$flagId': typeof LayoutInsiderFeaturesFlagIdRouteRoute
  '/insider/members/$memberId': typeof LayoutInsiderMembersMemberIdRouteRoute
  '/plo-solution-upload/gamemodes/$id': typeof LayoutPloSolutionUploadGamemodesIdRouteRouteWithChildren
  '/brevo/automations/': typeof LayoutBrevoAutomationsIndexRoute
  '/brevo/events/': typeof LayoutBrevoEventsIndexRoute
  '/brevo/revenue/': typeof LayoutBrevoRevenueIndexRoute
  '/feedback-forms/$formId/': typeof LayoutFeedbackFormsFormIdIndexRoute
  '/insider/features/': typeof LayoutInsiderFeaturesIndexRoute
  '/insider/members/': typeof LayoutInsiderMembersIndexRoute
  '/plo-solution-upload/gamemodes/': typeof LayoutPloSolutionUploadGamemodesIndexRoute
  '/brevo/events/$id/edit': typeof LayoutBrevoEventsIdEditRouteRoute
  '/brevo/events/$id/test-fire': typeof LayoutBrevoEventsIdTestFireRouteRoute
  '/plo-solution-upload/gamemodes/$id/upload': typeof LayoutPloSolutionUploadGamemodesIdUploadRouteRoute
  '/plo-solution-upload/gamemodes/$id/': typeof LayoutPloSolutionUploadGamemodesIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRouteWithChildren
  '/': typeof LayoutIndexRoute
  '/analyzer-insights/help': typeof LayoutAnalyzerInsightsHelpRouteRoute
  '/analyzer-insights/quota': typeof LayoutAnalyzerInsightsQuotaRouteRoute
  '/analyzer-insights/rooms': typeof LayoutAnalyzerInsightsRoomsRouteRoute
  '/analyzer-insights/spots': typeof LayoutAnalyzerInsightsSpotsRouteRoute
  '/analyzer-insights/users': typeof LayoutAnalyzerInsightsUsersRouteRoute
  '/announcements/$announcementId': typeof LayoutAnnouncementsAnnouncementIdRouteRoute
  '/announcements/help': typeof LayoutAnnouncementsHelpRouteRoute
  '/announcements/logs': typeof LayoutAnnouncementsLogsRouteRoute
  '/announcements/new': typeof LayoutAnnouncementsNewRouteRoute
  '/brevo/contacts': typeof LayoutBrevoContactsRouteRoute
  '/brevo/delivery-log': typeof LayoutBrevoDeliveryLogRouteRoute
  '/brevo/help': typeof LayoutBrevoHelpRouteRoute
  '/brevo/insights': typeof LayoutBrevoInsightsRouteRoute
  '/brevo/settings': typeof LayoutBrevoSettingsRouteRoute
  '/feedback-forms/help': typeof LayoutFeedbackFormsHelpRouteRoute
  '/feedback-forms/new': typeof LayoutFeedbackFormsNewRouteRoute
  '/insider/help': typeof LayoutInsiderHelpRouteRoute
  '/plo-solution-upload/gametypes': typeof LayoutPloSolutionUploadGametypesRouteRoute
  '/plo-solution-upload/help': typeof LayoutPloSolutionUploadHelpRouteRoute
  '/plo-solution-upload/upload-jobs': typeof LayoutPloSolutionUploadUploadJobsRouteRoute
  '/spot-of-the-week/$weekId': typeof LayoutSpotOfTheWeekWeekIdRouteRoute
  '/spot-of-the-week/help': typeof LayoutSpotOfTheWeekHelpRouteRoute
  '/analyzer-insights': typeof LayoutAnalyzerInsightsIndexRoute
  '/announcements': typeof LayoutAnnouncementsIndexRoute
  '/brevo': typeof LayoutBrevoIndexRoute
  '/feedback-forms': typeof LayoutFeedbackFormsIndexRoute
  '/spot-of-the-week': typeof LayoutSpotOfTheWeekIndexRoute
  '/login/oauth': typeof LoginOauthIndexRoute
  '/brevo/automations/churn-winback': typeof LayoutBrevoAutomationsChurnWinbackRouteRoute
  '/brevo/events/new': typeof LayoutBrevoEventsNewRouteRoute
  '/brevo/revenue/$id': typeof LayoutBrevoRevenueIdRouteRoute
  '/brevo/revenue/compare': typeof LayoutBrevoRevenueCompareRouteRoute
  '/feedback-forms/$formId/results': typeof LayoutFeedbackFormsFormIdResultsRouteRoute
  '/insider/features/$flagId': typeof LayoutInsiderFeaturesFlagIdRouteRoute
  '/insider/members/$memberId': typeof LayoutInsiderMembersMemberIdRouteRoute
  '/brevo/automations': typeof LayoutBrevoAutomationsIndexRoute
  '/brevo/events': typeof LayoutBrevoEventsIndexRoute
  '/brevo/revenue': typeof LayoutBrevoRevenueIndexRoute
  '/feedback-forms/$formId': typeof LayoutFeedbackFormsFormIdIndexRoute
  '/insider/features': typeof LayoutInsiderFeaturesIndexRoute
  '/insider/members': typeof LayoutInsiderMembersIndexRoute
  '/plo-solution-upload/gamemodes': typeof LayoutPloSolutionUploadGamemodesIndexRoute
  '/brevo/events/$id/edit': typeof LayoutBrevoEventsIdEditRouteRoute
  '/brevo/events/$id/test-fire': typeof LayoutBrevoEventsIdTestFireRouteRoute
  '/plo-solution-upload/gamemodes/$id/upload': typeof LayoutPloSolutionUploadGamemodesIdUploadRouteRoute
  '/plo-solution-upload/gamemodes/$id': typeof LayoutPloSolutionUploadGamemodesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRouteWithChildren
  '/_layout/analyzer-insights': typeof LayoutAnalyzerInsightsRouteRouteWithChildren
  '/_layout/announcements': typeof LayoutAnnouncementsRouteRouteWithChildren
  '/_layout/brevo': typeof LayoutBrevoRouteRouteWithChildren
  '/_layout/feedback-forms': typeof LayoutFeedbackFormsRouteRouteWithChildren
  '/_layout/spot-of-the-week': typeof LayoutSpotOfTheWeekRouteRouteWithChildren
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/analyzer-insights/help': typeof LayoutAnalyzerInsightsHelpRouteRoute
  '/_layout/analyzer-insights/quota': typeof LayoutAnalyzerInsightsQuotaRouteRoute
  '/_layout/analyzer-insights/rooms': typeof LayoutAnalyzerInsightsRoomsRouteRoute
  '/_layout/analyzer-insights/spots': typeof LayoutAnalyzerInsightsSpotsRouteRoute
  '/_layout/analyzer-insights/users': typeof LayoutAnalyzerInsightsUsersRouteRoute
  '/_layout/announcements/$announcementId': typeof LayoutAnnouncementsAnnouncementIdRouteRoute
  '/_layout/announcements/help': typeof LayoutAnnouncementsHelpRouteRoute
  '/_layout/announcements/logs': typeof LayoutAnnouncementsLogsRouteRoute
  '/_layout/announcements/new': typeof LayoutAnnouncementsNewRouteRoute
  '/_layout/brevo/automations': typeof LayoutBrevoAutomationsRouteRouteWithChildren
  '/_layout/brevo/contacts': typeof LayoutBrevoContactsRouteRoute
  '/_layout/brevo/delivery-log': typeof LayoutBrevoDeliveryLogRouteRoute
  '/_layout/brevo/events': typeof LayoutBrevoEventsRouteRouteWithChildren
  '/_layout/brevo/help': typeof LayoutBrevoHelpRouteRoute
  '/_layout/brevo/insights': typeof LayoutBrevoInsightsRouteRoute
  '/_layout/brevo/revenue': typeof LayoutBrevoRevenueRouteRouteWithChildren
  '/_layout/brevo/settings': typeof LayoutBrevoSettingsRouteRoute
  '/_layout/feedback-forms/$formId': typeof LayoutFeedbackFormsFormIdRouteRouteWithChildren
  '/_layout/feedback-forms/help': typeof LayoutFeedbackFormsHelpRouteRoute
  '/_layout/feedback-forms/new': typeof LayoutFeedbackFormsNewRouteRoute
  '/_layout/insider/features': typeof LayoutInsiderFeaturesRouteRouteWithChildren
  '/_layout/insider/help': typeof LayoutInsiderHelpRouteRoute
  '/_layout/insider/members': typeof LayoutInsiderMembersRouteRouteWithChildren
  '/_layout/plo-solution-upload/gamemodes': typeof LayoutPloSolutionUploadGamemodesRouteRouteWithChildren
  '/_layout/plo-solution-upload/gametypes': typeof LayoutPloSolutionUploadGametypesRouteRoute
  '/_layout/plo-solution-upload/help': typeof LayoutPloSolutionUploadHelpRouteRoute
  '/_layout/plo-solution-upload/upload-jobs': typeof LayoutPloSolutionUploadUploadJobsRouteRoute
  '/_layout/spot-of-the-week/$weekId': typeof LayoutSpotOfTheWeekWeekIdRouteRoute
  '/_layout/spot-of-the-week/help': typeof LayoutSpotOfTheWeekHelpRouteRoute
  '/_layout/analyzer-insights/': typeof LayoutAnalyzerInsightsIndexRoute
  '/_layout/announcements/': typeof LayoutAnnouncementsIndexRoute
  '/_layout/brevo/': typeof LayoutBrevoIndexRoute
  '/_layout/feedback-forms/': typeof LayoutFeedbackFormsIndexRoute
  '/_layout/spot-of-the-week/': typeof LayoutSpotOfTheWeekIndexRoute
  '/login/oauth/': typeof LoginOauthIndexRoute
  '/_layout/brevo/automations/churn-winback': typeof LayoutBrevoAutomationsChurnWinbackRouteRoute
  '/_layout/brevo/events/new': typeof LayoutBrevoEventsNewRouteRoute
  '/_layout/brevo/revenue/$id': typeof LayoutBrevoRevenueIdRouteRoute
  '/_layout/brevo/revenue/compare': typeof LayoutBrevoRevenueCompareRouteRoute
  '/_layout/feedback-forms/$formId/results': typeof LayoutFeedbackFormsFormIdResultsRouteRoute
  '/_layout/insider/features/$flagId': typeof LayoutInsiderFeaturesFlagIdRouteRoute
  '/_layout/insider/members/$memberId': typeof LayoutInsiderMembersMemberIdRouteRoute
  '/_layout/plo-solution-upload/gamemodes/$id': typeof LayoutPloSolutionUploadGamemodesIdRouteRouteWithChildren
  '/_layout/brevo/automations/': typeof LayoutBrevoAutomationsIndexRoute
  '/_layout/brevo/events/': typeof LayoutBrevoEventsIndexRoute
  '/_layout/brevo/revenue/': typeof LayoutBrevoRevenueIndexRoute
  '/_layout/feedback-forms/$formId/': typeof LayoutFeedbackFormsFormIdIndexRoute
  '/_layout/insider/features/': typeof LayoutInsiderFeaturesIndexRoute
  '/_layout/insider/members/': typeof LayoutInsiderMembersIndexRoute
  '/_layout/plo-solution-upload/gamemodes/': typeof LayoutPloSolutionUploadGamemodesIndexRoute
  '/_layout/brevo/events/$id/edit': typeof LayoutBrevoEventsIdEditRouteRoute
  '/_layout/brevo/events/$id/test-fire': typeof LayoutBrevoEventsIdTestFireRouteRoute
  '/_layout/plo-solution-upload/gamemodes/$id/upload': typeof LayoutPloSolutionUploadGamemodesIdUploadRouteRoute
  '/_layout/plo-solution-upload/gamemodes/$id/': typeof LayoutPloSolutionUploadGamemodesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analyzer-insights'
    | '/announcements'
    | '/brevo'
    | '/feedback-forms'
    | '/spot-of-the-week'
    | '/analyzer-insights/help'
    | '/analyzer-insights/quota'
    | '/analyzer-insights/rooms'
    | '/analyzer-insights/spots'
    | '/analyzer-insights/users'
    | '/announcements/$announcementId'
    | '/announcements/help'
    | '/announcements/logs'
    | '/announcements/new'
    | '/brevo/automations'
    | '/brevo/contacts'
    | '/brevo/delivery-log'
    | '/brevo/events'
    | '/brevo/help'
    | '/brevo/insights'
    | '/brevo/revenue'
    | '/brevo/settings'
    | '/feedback-forms/$formId'
    | '/feedback-forms/help'
    | '/feedback-forms/new'
    | '/insider/features'
    | '/insider/help'
    | '/insider/members'
    | '/plo-solution-upload/gamemodes'
    | '/plo-solution-upload/gametypes'
    | '/plo-solution-upload/help'
    | '/plo-solution-upload/upload-jobs'
    | '/spot-of-the-week/$weekId'
    | '/spot-of-the-week/help'
    | '/analyzer-insights/'
    | '/announcements/'
    | '/brevo/'
    | '/feedback-forms/'
    | '/spot-of-the-week/'
    | '/login/oauth/'
    | '/brevo/automations/churn-winback'
    | '/brevo/events/new'
    | '/brevo/revenue/$id'
    | '/brevo/revenue/compare'
    | '/feedback-forms/$formId/results'
    | '/insider/features/$flagId'
    | '/insider/members/$memberId'
    | '/plo-solution-upload/gamemodes/$id'
    | '/brevo/automations/'
    | '/brevo/events/'
    | '/brevo/revenue/'
    | '/feedback-forms/$formId/'
    | '/insider/features/'
    | '/insider/members/'
    | '/plo-solution-upload/gamemodes/'
    | '/brevo/events/$id/edit'
    | '/brevo/events/$id/test-fire'
    | '/plo-solution-upload/gamemodes/$id/upload'
    | '/plo-solution-upload/gamemodes/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/analyzer-insights/help'
    | '/analyzer-insights/quota'
    | '/analyzer-insights/rooms'
    | '/analyzer-insights/spots'
    | '/analyzer-insights/users'
    | '/announcements/$announcementId'
    | '/announcements/help'
    | '/announcements/logs'
    | '/announcements/new'
    | '/brevo/contacts'
    | '/brevo/delivery-log'
    | '/brevo/help'
    | '/brevo/insights'
    | '/brevo/settings'
    | '/feedback-forms/help'
    | '/feedback-forms/new'
    | '/insider/help'
    | '/plo-solution-upload/gametypes'
    | '/plo-solution-upload/help'
    | '/plo-solution-upload/upload-jobs'
    | '/spot-of-the-week/$weekId'
    | '/spot-of-the-week/help'
    | '/analyzer-insights'
    | '/announcements'
    | '/brevo'
    | '/feedback-forms'
    | '/spot-of-the-week'
    | '/login/oauth'
    | '/brevo/automations/churn-winback'
    | '/brevo/events/new'
    | '/brevo/revenue/$id'
    | '/brevo/revenue/compare'
    | '/feedback-forms/$formId/results'
    | '/insider/features/$flagId'
    | '/insider/members/$memberId'
    | '/brevo/automations'
    | '/brevo/events'
    | '/brevo/revenue'
    | '/feedback-forms/$formId'
    | '/insider/features'
    | '/insider/members'
    | '/plo-solution-upload/gamemodes'
    | '/brevo/events/$id/edit'
    | '/brevo/events/$id/test-fire'
    | '/plo-solution-upload/gamemodes/$id/upload'
    | '/plo-solution-upload/gamemodes/$id'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/_layout/analyzer-insights'
    | '/_layout/announcements'
    | '/_layout/brevo'
    | '/_layout/feedback-forms'
    | '/_layout/spot-of-the-week'
    | '/_layout/'
    | '/_layout/analyzer-insights/help'
    | '/_layout/analyzer-insights/quota'
    | '/_layout/analyzer-insights/rooms'
    | '/_layout/analyzer-insights/spots'
    | '/_layout/analyzer-insights/users'
    | '/_layout/announcements/$announcementId'
    | '/_layout/announcements/help'
    | '/_layout/announcements/logs'
    | '/_layout/announcements/new'
    | '/_layout/brevo/automations'
    | '/_layout/brevo/contacts'
    | '/_layout/brevo/delivery-log'
    | '/_layout/brevo/events'
    | '/_layout/brevo/help'
    | '/_layout/brevo/insights'
    | '/_layout/brevo/revenue'
    | '/_layout/brevo/settings'
    | '/_layout/feedback-forms/$formId'
    | '/_layout/feedback-forms/help'
    | '/_layout/feedback-forms/new'
    | '/_layout/insider/features'
    | '/_layout/insider/help'
    | '/_layout/insider/members'
    | '/_layout/plo-solution-upload/gamemodes'
    | '/_layout/plo-solution-upload/gametypes'
    | '/_layout/plo-solution-upload/help'
    | '/_layout/plo-solution-upload/upload-jobs'
    | '/_layout/spot-of-the-week/$weekId'
    | '/_layout/spot-of-the-week/help'
    | '/_layout/analyzer-insights/'
    | '/_layout/announcements/'
    | '/_layout/brevo/'
    | '/_layout/feedback-forms/'
    | '/_layout/spot-of-the-week/'
    | '/login/oauth/'
    | '/_layout/brevo/automations/churn-winback'
    | '/_layout/brevo/events/new'
    | '/_layout/brevo/revenue/$id'
    | '/_layout/brevo/revenue/compare'
    | '/_layout/feedback-forms/$formId/results'
    | '/_layout/insider/features/$flagId'
    | '/_layout/insider/members/$memberId'
    | '/_layout/plo-solution-upload/gamemodes/$id'
    | '/_layout/brevo/automations/'
    | '/_layout/brevo/events/'
    | '/_layout/brevo/revenue/'
    | '/_layout/feedback-forms/$formId/'
    | '/_layout/insider/features/'
    | '/_layout/insider/members/'
    | '/_layout/plo-solution-upload/gamemodes/'
    | '/_layout/brevo/events/$id/edit'
    | '/_layout/brevo/events/$id/test-fire'
    | '/_layout/plo-solution-upload/gamemodes/$id/upload'
    | '/_layout/plo-solution-upload/gamemodes/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/analyzer-insights': {
      id: '/_layout/analyzer-insights'
      path: '/analyzer-insights'
      fullPath: '/analyzer-insights'
      preLoaderRoute: typeof LayoutAnalyzerInsightsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/announcements': {
      id: '/_layout/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof LayoutAnnouncementsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/brevo': {
      id: '/_layout/brevo'
      path: '/brevo'
      fullPath: '/brevo'
      preLoaderRoute: typeof LayoutBrevoRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/feedback-forms': {
      id: '/_layout/feedback-forms'
      path: '/feedback-forms'
      fullPath: '/feedback-forms'
      preLoaderRoute: typeof LayoutFeedbackFormsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/spot-of-the-week': {
      id: '/_layout/spot-of-the-week'
      path: '/spot-of-the-week'
      fullPath: '/spot-of-the-week'
      preLoaderRoute: typeof LayoutSpotOfTheWeekRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/analyzer-insights/': {
      id: '/_layout/analyzer-insights/'
      path: '/'
      fullPath: '/analyzer-insights/'
      preLoaderRoute: typeof LayoutAnalyzerInsightsIndexRouteImport
      parentRoute: typeof LayoutAnalyzerInsightsRouteRoute
    }
    '/_layout/analyzer-insights/help': {
      id: '/_layout/analyzer-insights/help'
      path: '/help'
      fullPath: '/analyzer-insights/help'
      preLoaderRoute: typeof LayoutAnalyzerInsightsHelpRouteRouteImport
      parentRoute: typeof LayoutAnalyzerInsightsRouteRoute
    }
    '/_layout/analyzer-insights/quota': {
      id: '/_layout/analyzer-insights/quota'
      path: '/quota'
      fullPath: '/analyzer-insights/quota'
      preLoaderRoute: typeof LayoutAnalyzerInsightsQuotaRouteRouteImport
      parentRoute: typeof LayoutAnalyzerInsightsRouteRoute
    }
    '/_layout/analyzer-insights/rooms': {
      id: '/_layout/analyzer-insights/rooms'
      path: '/rooms'
      fullPath: '/analyzer-insights/rooms'
      preLoaderRoute: typeof LayoutAnalyzerInsightsRoomsRouteRouteImport
      parentRoute: typeof LayoutAnalyzerInsightsRouteRoute
    }
    '/_layout/analyzer-insights/spots': {
      id: '/_layout/analyzer-insights/spots'
      path: '/spots'
      fullPath: '/analyzer-insights/spots'
      preLoaderRoute: typeof LayoutAnalyzerInsightsSpotsRouteRouteImport
      parentRoute: typeof LayoutAnalyzerInsightsRouteRoute
    }
    '/_layout/analyzer-insights/users': {
      id: '/_layout/analyzer-insights/users'
      path: '/users'
      fullPath: '/analyzer-insights/users'
      preLoaderRoute: typeof LayoutAnalyzerInsightsUsersRouteRouteImport
      parentRoute: typeof LayoutAnalyzerInsightsRouteRoute
    }
    '/_layout/announcements/': {
      id: '/_layout/announcements/'
      path: '/'
      fullPath: '/announcements/'
      preLoaderRoute: typeof LayoutAnnouncementsIndexRouteImport
      parentRoute: typeof LayoutAnnouncementsRouteRoute
    }
    '/_layout/announcements/$announcementId': {
      id: '/_layout/announcements/$announcementId'
      path: '/$announcementId'
      fullPath: '/announcements/$announcementId'
      preLoaderRoute: typeof LayoutAnnouncementsAnnouncementIdRouteRouteImport
      parentRoute: typeof LayoutAnnouncementsRouteRoute
    }
    '/_layout/announcements/help': {
      id: '/_layout/announcements/help'
      path: '/help'
      fullPath: '/announcements/help'
      preLoaderRoute: typeof LayoutAnnouncementsHelpRouteRouteImport
      parentRoute: typeof LayoutAnnouncementsRouteRoute
    }
    '/_layout/announcements/logs': {
      id: '/_layout/announcements/logs'
      path: '/logs'
      fullPath: '/announcements/logs'
      preLoaderRoute: typeof LayoutAnnouncementsLogsRouteRouteImport
      parentRoute: typeof LayoutAnnouncementsRouteRoute
    }
    '/_layout/announcements/new': {
      id: '/_layout/announcements/new'
      path: '/new'
      fullPath: '/announcements/new'
      preLoaderRoute: typeof LayoutAnnouncementsNewRouteRouteImport
      parentRoute: typeof LayoutAnnouncementsRouteRoute
    }
    '/_layout/brevo/': {
      id: '/_layout/brevo/'
      path: '/'
      fullPath: '/brevo/'
      preLoaderRoute: typeof LayoutBrevoIndexRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/automations': {
      id: '/_layout/brevo/automations'
      path: '/automations'
      fullPath: '/brevo/automations'
      preLoaderRoute: typeof LayoutBrevoAutomationsRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/contacts': {
      id: '/_layout/brevo/contacts'
      path: '/contacts'
      fullPath: '/brevo/contacts'
      preLoaderRoute: typeof LayoutBrevoContactsRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/delivery-log': {
      id: '/_layout/brevo/delivery-log'
      path: '/delivery-log'
      fullPath: '/brevo/delivery-log'
      preLoaderRoute: typeof LayoutBrevoDeliveryLogRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/events': {
      id: '/_layout/brevo/events'
      path: '/events'
      fullPath: '/brevo/events'
      preLoaderRoute: typeof LayoutBrevoEventsRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/help': {
      id: '/_layout/brevo/help'
      path: '/help'
      fullPath: '/brevo/help'
      preLoaderRoute: typeof LayoutBrevoHelpRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/insights': {
      id: '/_layout/brevo/insights'
      path: '/insights'
      fullPath: '/brevo/insights'
      preLoaderRoute: typeof LayoutBrevoInsightsRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/revenue': {
      id: '/_layout/brevo/revenue'
      path: '/revenue'
      fullPath: '/brevo/revenue'
      preLoaderRoute: typeof LayoutBrevoRevenueRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/brevo/settings': {
      id: '/_layout/brevo/settings'
      path: '/settings'
      fullPath: '/brevo/settings'
      preLoaderRoute: typeof LayoutBrevoSettingsRouteRouteImport
      parentRoute: typeof LayoutBrevoRouteRoute
    }
    '/_layout/feedback-forms/': {
      id: '/_layout/feedback-forms/'
      path: '/'
      fullPath: '/feedback-forms/'
      preLoaderRoute: typeof LayoutFeedbackFormsIndexRouteImport
      parentRoute: typeof LayoutFeedbackFormsRouteRoute
    }
    '/_layout/feedback-forms/$formId': {
      id: '/_layout/feedback-forms/$formId'
      path: '/$formId'
      fullPath: '/feedback-forms/$formId'
      preLoaderRoute: typeof LayoutFeedbackFormsFormIdRouteRouteImport
      parentRoute: typeof LayoutFeedbackFormsRouteRoute
    }
    '/_layout/feedback-forms/help': {
      id: '/_layout/feedback-forms/help'
      path: '/help'
      fullPath: '/feedback-forms/help'
      preLoaderRoute: typeof LayoutFeedbackFormsHelpRouteRouteImport
      parentRoute: typeof LayoutFeedbackFormsRouteRoute
    }
    '/_layout/feedback-forms/new': {
      id: '/_layout/feedback-forms/new'
      path: '/new'
      fullPath: '/feedback-forms/new'
      preLoaderRoute: typeof LayoutFeedbackFormsNewRouteRouteImport
      parentRoute: typeof LayoutFeedbackFormsRouteRoute
    }
    '/_layout/insider/features': {
      id: '/_layout/insider/features'
      path: '/insider/features'
      fullPath: '/insider/features'
      preLoaderRoute: typeof LayoutInsiderFeaturesRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/insider/help': {
      id: '/_layout/insider/help'
      path: '/insider/help'
      fullPath: '/insider/help'
      preLoaderRoute: typeof LayoutInsiderHelpRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/insider/members': {
      id: '/_layout/insider/members'
      path: '/insider/members'
      fullPath: '/insider/members'
      preLoaderRoute: typeof LayoutInsiderMembersRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/plo-solution-upload/gamemodes': {
      id: '/_layout/plo-solution-upload/gamemodes'
      path: '/plo-solution-upload/gamemodes'
      fullPath: '/plo-solution-upload/gamemodes'
      preLoaderRoute: typeof LayoutPloSolutionUploadGamemodesRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/plo-solution-upload/gametypes': {
      id: '/_layout/plo-solution-upload/gametypes'
      path: '/plo-solution-upload/gametypes'
      fullPath: '/plo-solution-upload/gametypes'
      preLoaderRoute: typeof LayoutPloSolutionUploadGametypesRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/plo-solution-upload/help': {
      id: '/_layout/plo-solution-upload/help'
      path: '/plo-solution-upload/help'
      fullPath: '/plo-solution-upload/help'
      preLoaderRoute: typeof LayoutPloSolutionUploadHelpRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/plo-solution-upload/upload-jobs': {
      id: '/_layout/plo-solution-upload/upload-jobs'
      path: '/plo-solution-upload/upload-jobs'
      fullPath: '/plo-solution-upload/upload-jobs'
      preLoaderRoute: typeof LayoutPloSolutionUploadUploadJobsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/spot-of-the-week/': {
      id: '/_layout/spot-of-the-week/'
      path: '/'
      fullPath: '/spot-of-the-week/'
      preLoaderRoute: typeof LayoutSpotOfTheWeekIndexRouteImport
      parentRoute: typeof LayoutSpotOfTheWeekRouteRoute
    }
    '/_layout/spot-of-the-week/$weekId': {
      id: '/_layout/spot-of-the-week/$weekId'
      path: '/$weekId'
      fullPath: '/spot-of-the-week/$weekId'
      preLoaderRoute: typeof LayoutSpotOfTheWeekWeekIdRouteRouteImport
      parentRoute: typeof LayoutSpotOfTheWeekRouteRoute
    }
    '/_layout/spot-of-the-week/help': {
      id: '/_layout/spot-of-the-week/help'
      path: '/help'
      fullPath: '/spot-of-the-week/help'
      preLoaderRoute: typeof LayoutSpotOfTheWeekHelpRouteRouteImport
      parentRoute: typeof LayoutSpotOfTheWeekRouteRoute
    }
    '/login/oauth/': {
      id: '/login/oauth/'
      path: '/oauth'
      fullPath: '/login/oauth/'
      preLoaderRoute: typeof LoginOauthIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_layout/brevo/automations/': {
      id: '/_layout/brevo/automations/'
      path: '/'
      fullPath: '/brevo/automations/'
      preLoaderRoute: typeof LayoutBrevoAutomationsIndexRouteImport
      parentRoute: typeof LayoutBrevoAutomationsRouteRoute
    }
    '/_layout/brevo/automations/churn-winback': {
      id: '/_layout/brevo/automations/churn-winback'
      path: '/churn-winback'
      fullPath: '/brevo/automations/churn-winback'
      preLoaderRoute: typeof LayoutBrevoAutomationsChurnWinbackRouteRouteImport
      parentRoute: typeof LayoutBrevoAutomationsRouteRoute
    }
    '/_layout/brevo/events/': {
      id: '/_layout/brevo/events/'
      path: '/'
      fullPath: '/brevo/events/'
      preLoaderRoute: typeof LayoutBrevoEventsIndexRouteImport
      parentRoute: typeof LayoutBrevoEventsRouteRoute
    }
    '/_layout/brevo/events/new': {
      id: '/_layout/brevo/events/new'
      path: '/new'
      fullPath: '/brevo/events/new'
      preLoaderRoute: typeof LayoutBrevoEventsNewRouteRouteImport
      parentRoute: typeof LayoutBrevoEventsRouteRoute
    }
    '/_layout/brevo/revenue/': {
      id: '/_layout/brevo/revenue/'
      path: '/'
      fullPath: '/brevo/revenue/'
      preLoaderRoute: typeof LayoutBrevoRevenueIndexRouteImport
      parentRoute: typeof LayoutBrevoRevenueRouteRoute
    }
    '/_layout/brevo/revenue/$id': {
      id: '/_layout/brevo/revenue/$id'
      path: '/$id'
      fullPath: '/brevo/revenue/$id'
      preLoaderRoute: typeof LayoutBrevoRevenueIdRouteRouteImport
      parentRoute: typeof LayoutBrevoRevenueRouteRoute
    }
    '/_layout/brevo/revenue/compare': {
      id: '/_layout/brevo/revenue/compare'
      path: '/compare'
      fullPath: '/brevo/revenue/compare'
      preLoaderRoute: typeof LayoutBrevoRevenueCompareRouteRouteImport
      parentRoute: typeof LayoutBrevoRevenueRouteRoute
    }
    '/_layout/feedback-forms/$formId/': {
      id: '/_layout/feedback-forms/$formId/'
      path: '/'
      fullPath: '/feedback-forms/$formId/'
      preLoaderRoute: typeof LayoutFeedbackFormsFormIdIndexRouteImport
      parentRoute: typeof LayoutFeedbackFormsFormIdRouteRoute
    }
    '/_layout/feedback-forms/$formId/results': {
      id: '/_layout/feedback-forms/$formId/results'
      path: '/results'
      fullPath: '/feedback-forms/$formId/results'
      preLoaderRoute: typeof LayoutFeedbackFormsFormIdResultsRouteRouteImport
      parentRoute: typeof LayoutFeedbackFormsFormIdRouteRoute
    }
    '/_layout/insider/features/': {
      id: '/_layout/insider/features/'
      path: '/'
      fullPath: '/insider/features/'
      preLoaderRoute: typeof LayoutInsiderFeaturesIndexRouteImport
      parentRoute: typeof LayoutInsiderFeaturesRouteRoute
    }
    '/_layout/insider/features/$flagId': {
      id: '/_layout/insider/features/$flagId'
      path: '/$flagId'
      fullPath: '/insider/features/$flagId'
      preLoaderRoute: typeof LayoutInsiderFeaturesFlagIdRouteRouteImport
      parentRoute: typeof LayoutInsiderFeaturesRouteRoute
    }
    '/_layout/insider/members/': {
      id: '/_layout/insider/members/'
      path: '/'
      fullPath: '/insider/members/'
      preLoaderRoute: typeof LayoutInsiderMembersIndexRouteImport
      parentRoute: typeof LayoutInsiderMembersRouteRoute
    }
    '/_layout/insider/members/$memberId': {
      id: '/_layout/insider/members/$memberId'
      path: '/$memberId'
      fullPath: '/insider/members/$memberId'
      preLoaderRoute: typeof LayoutInsiderMembersMemberIdRouteRouteImport
      parentRoute: typeof LayoutInsiderMembersRouteRoute
    }
    '/_layout/plo-solution-upload/gamemodes/': {
      id: '/_layout/plo-solution-upload/gamemodes/'
      path: '/'
      fullPath: '/plo-solution-upload/gamemodes/'
      preLoaderRoute: typeof LayoutPloSolutionUploadGamemodesIndexRouteImport
      parentRoute: typeof LayoutPloSolutionUploadGamemodesRouteRoute
    }
    '/_layout/plo-solution-upload/gamemodes/$id': {
      id: '/_layout/plo-solution-upload/gamemodes/$id'
      path: '/$id'
      fullPath: '/plo-solution-upload/gamemodes/$id'
      preLoaderRoute: typeof LayoutPloSolutionUploadGamemodesIdRouteRouteImport
      parentRoute: typeof LayoutPloSolutionUploadGamemodesRouteRoute
    }
    '/_layout/brevo/events/$id/edit': {
      id: '/_layout/brevo/events/$id/edit'
      path: '/$id/edit'
      fullPath: '/brevo/events/$id/edit'
      preLoaderRoute: typeof LayoutBrevoEventsIdEditRouteRouteImport
      parentRoute: typeof LayoutBrevoEventsRouteRoute
    }
    '/_layout/brevo/events/$id/test-fire': {
      id: '/_layout/brevo/events/$id/test-fire'
      path: '/$id/test-fire'
      fullPath: '/brevo/events/$id/test-fire'
      preLoaderRoute: typeof LayoutBrevoEventsIdTestFireRouteRouteImport
      parentRoute: typeof LayoutBrevoEventsRouteRoute
    }
    '/_layout/plo-solution-upload/gamemodes/$id/': {
      id: '/_layout/plo-solution-upload/gamemodes/$id/'
      path: '/'
      fullPath: '/plo-solution-upload/gamemodes/$id/'
      preLoaderRoute: typeof LayoutPloSolutionUploadGamemodesIdIndexRouteImport
      parentRoute: typeof LayoutPloSolutionUploadGamemodesIdRouteRoute
    }
    '/_layout/plo-solution-upload/gamemodes/$id/upload': {
      id: '/_layout/plo-solution-upload/gamemodes/$id/upload'
      path: '/upload'
      fullPath: '/plo-solution-upload/gamemodes/$id/upload'
      preLoaderRoute: typeof LayoutPloSolutionUploadGamemodesIdUploadRouteRouteImport
      parentRoute: typeof LayoutPloSolutionUploadGamemodesIdRouteRoute
    }
  }
}

interface LayoutAnalyzerInsightsRouteRouteChildren {
  LayoutAnalyzerInsightsHelpRouteRoute: typeof LayoutAnalyzerInsightsHelpRouteRoute
  LayoutAnalyzerInsightsQuotaRouteRoute: typeof LayoutAnalyzerInsightsQuotaRouteRoute
  LayoutAnalyzerInsightsRoomsRouteRoute: typeof LayoutAnalyzerInsightsRoomsRouteRoute
  LayoutAnalyzerInsightsSpotsRouteRoute: typeof LayoutAnalyzerInsightsSpotsRouteRoute
  LayoutAnalyzerInsightsUsersRouteRoute: typeof LayoutAnalyzerInsightsUsersRouteRoute
  LayoutAnalyzerInsightsIndexRoute: typeof LayoutAnalyzerInsightsIndexRoute
}

const LayoutAnalyzerInsightsRouteRouteChildren: LayoutAnalyzerInsightsRouteRouteChildren =
  {
    LayoutAnalyzerInsightsHelpRouteRoute: LayoutAnalyzerInsightsHelpRouteRoute,
    LayoutAnalyzerInsightsQuotaRouteRoute:
      LayoutAnalyzerInsightsQuotaRouteRoute,
    LayoutAnalyzerInsightsRoomsRouteRoute:
      LayoutAnalyzerInsightsRoomsRouteRoute,
    LayoutAnalyzerInsightsSpotsRouteRoute:
      LayoutAnalyzerInsightsSpotsRouteRoute,
    LayoutAnalyzerInsightsUsersRouteRoute:
      LayoutAnalyzerInsightsUsersRouteRoute,
    LayoutAnalyzerInsightsIndexRoute: LayoutAnalyzerInsightsIndexRoute,
  }

const LayoutAnalyzerInsightsRouteRouteWithChildren =
  LayoutAnalyzerInsightsRouteRoute._addFileChildren(
    LayoutAnalyzerInsightsRouteRouteChildren,
  )

interface LayoutAnnouncementsRouteRouteChildren {
  LayoutAnnouncementsAnnouncementIdRouteRoute: typeof LayoutAnnouncementsAnnouncementIdRouteRoute
  LayoutAnnouncementsHelpRouteRoute: typeof LayoutAnnouncementsHelpRouteRoute
  LayoutAnnouncementsLogsRouteRoute: typeof LayoutAnnouncementsLogsRouteRoute
  LayoutAnnouncementsNewRouteRoute: typeof LayoutAnnouncementsNewRouteRoute
  LayoutAnnouncementsIndexRoute: typeof LayoutAnnouncementsIndexRoute
}

const LayoutAnnouncementsRouteRouteChildren: LayoutAnnouncementsRouteRouteChildren =
  {
    LayoutAnnouncementsAnnouncementIdRouteRoute:
      LayoutAnnouncementsAnnouncementIdRouteRoute,
    LayoutAnnouncementsHelpRouteRoute: LayoutAnnouncementsHelpRouteRoute,
    LayoutAnnouncementsLogsRouteRoute: LayoutAnnouncementsLogsRouteRoute,
    LayoutAnnouncementsNewRouteRoute: LayoutAnnouncementsNewRouteRoute,
    LayoutAnnouncementsIndexRoute: LayoutAnnouncementsIndexRoute,
  }

const LayoutAnnouncementsRouteRouteWithChildren =
  LayoutAnnouncementsRouteRoute._addFileChildren(
    LayoutAnnouncementsRouteRouteChildren,
  )

interface LayoutBrevoAutomationsRouteRouteChildren {
  LayoutBrevoAutomationsChurnWinbackRouteRoute: typeof LayoutBrevoAutomationsChurnWinbackRouteRoute
  LayoutBrevoAutomationsIndexRoute: typeof LayoutBrevoAutomationsIndexRoute
}

const LayoutBrevoAutomationsRouteRouteChildren: LayoutBrevoAutomationsRouteRouteChildren =
  {
    LayoutBrevoAutomationsChurnWinbackRouteRoute:
      LayoutBrevoAutomationsChurnWinbackRouteRoute,
    LayoutBrevoAutomationsIndexRoute: LayoutBrevoAutomationsIndexRoute,
  }

const LayoutBrevoAutomationsRouteRouteWithChildren =
  LayoutBrevoAutomationsRouteRoute._addFileChildren(
    LayoutBrevoAutomationsRouteRouteChildren,
  )

interface LayoutBrevoEventsRouteRouteChildren {
  LayoutBrevoEventsNewRouteRoute: typeof LayoutBrevoEventsNewRouteRoute
  LayoutBrevoEventsIndexRoute: typeof LayoutBrevoEventsIndexRoute
  LayoutBrevoEventsIdEditRouteRoute: typeof LayoutBrevoEventsIdEditRouteRoute
  LayoutBrevoEventsIdTestFireRouteRoute: typeof LayoutBrevoEventsIdTestFireRouteRoute
}

const LayoutBrevoEventsRouteRouteChildren: LayoutBrevoEventsRouteRouteChildren =
  {
    LayoutBrevoEventsNewRouteRoute: LayoutBrevoEventsNewRouteRoute,
    LayoutBrevoEventsIndexRoute: LayoutBrevoEventsIndexRoute,
    LayoutBrevoEventsIdEditRouteRoute: LayoutBrevoEventsIdEditRouteRoute,
    LayoutBrevoEventsIdTestFireRouteRoute:
      LayoutBrevoEventsIdTestFireRouteRoute,
  }

const LayoutBrevoEventsRouteRouteWithChildren =
  LayoutBrevoEventsRouteRoute._addFileChildren(
    LayoutBrevoEventsRouteRouteChildren,
  )

interface LayoutBrevoRevenueRouteRouteChildren {
  LayoutBrevoRevenueIdRouteRoute: typeof LayoutBrevoRevenueIdRouteRoute
  LayoutBrevoRevenueCompareRouteRoute: typeof LayoutBrevoRevenueCompareRouteRoute
  LayoutBrevoRevenueIndexRoute: typeof LayoutBrevoRevenueIndexRoute
}

const LayoutBrevoRevenueRouteRouteChildren: LayoutBrevoRevenueRouteRouteChildren =
  {
    LayoutBrevoRevenueIdRouteRoute: LayoutBrevoRevenueIdRouteRoute,
    LayoutBrevoRevenueCompareRouteRoute: LayoutBrevoRevenueCompareRouteRoute,
    LayoutBrevoRevenueIndexRoute: LayoutBrevoRevenueIndexRoute,
  }

const LayoutBrevoRevenueRouteRouteWithChildren =
  LayoutBrevoRevenueRouteRoute._addFileChildren(
    LayoutBrevoRevenueRouteRouteChildren,
  )

interface LayoutBrevoRouteRouteChildren {
  LayoutBrevoAutomationsRouteRoute: typeof LayoutBrevoAutomationsRouteRouteWithChildren
  LayoutBrevoContactsRouteRoute: typeof LayoutBrevoContactsRouteRoute
  LayoutBrevoDeliveryLogRouteRoute: typeof LayoutBrevoDeliveryLogRouteRoute
  LayoutBrevoEventsRouteRoute: typeof LayoutBrevoEventsRouteRouteWithChildren
  LayoutBrevoHelpRouteRoute: typeof LayoutBrevoHelpRouteRoute
  LayoutBrevoInsightsRouteRoute: typeof LayoutBrevoInsightsRouteRoute
  LayoutBrevoRevenueRouteRoute: typeof LayoutBrevoRevenueRouteRouteWithChildren
  LayoutBrevoSettingsRouteRoute: typeof LayoutBrevoSettingsRouteRoute
  LayoutBrevoIndexRoute: typeof LayoutBrevoIndexRoute
}

const LayoutBrevoRouteRouteChildren: LayoutBrevoRouteRouteChildren = {
  LayoutBrevoAutomationsRouteRoute:
    LayoutBrevoAutomationsRouteRouteWithChildren,
  LayoutBrevoContactsRouteRoute: LayoutBrevoContactsRouteRoute,
  LayoutBrevoDeliveryLogRouteRoute: LayoutBrevoDeliveryLogRouteRoute,
  LayoutBrevoEventsRouteRoute: LayoutBrevoEventsRouteRouteWithChildren,
  LayoutBrevoHelpRouteRoute: LayoutBrevoHelpRouteRoute,
  LayoutBrevoInsightsRouteRoute: LayoutBrevoInsightsRouteRoute,
  LayoutBrevoRevenueRouteRoute: LayoutBrevoRevenueRouteRouteWithChildren,
  LayoutBrevoSettingsRouteRoute: LayoutBrevoSettingsRouteRoute,
  LayoutBrevoIndexRoute: LayoutBrevoIndexRoute,
}

const LayoutBrevoRouteRouteWithChildren =
  LayoutBrevoRouteRoute._addFileChildren(LayoutBrevoRouteRouteChildren)

interface LayoutFeedbackFormsFormIdRouteRouteChildren {
  LayoutFeedbackFormsFormIdResultsRouteRoute: typeof LayoutFeedbackFormsFormIdResultsRouteRoute
  LayoutFeedbackFormsFormIdIndexRoute: typeof LayoutFeedbackFormsFormIdIndexRoute
}

const LayoutFeedbackFormsFormIdRouteRouteChildren: LayoutFeedbackFormsFormIdRouteRouteChildren =
  {
    LayoutFeedbackFormsFormIdResultsRouteRoute:
      LayoutFeedbackFormsFormIdResultsRouteRoute,
    LayoutFeedbackFormsFormIdIndexRoute: LayoutFeedbackFormsFormIdIndexRoute,
  }

const LayoutFeedbackFormsFormIdRouteRouteWithChildren =
  LayoutFeedbackFormsFormIdRouteRoute._addFileChildren(
    LayoutFeedbackFormsFormIdRouteRouteChildren,
  )

interface LayoutFeedbackFormsRouteRouteChildren {
  LayoutFeedbackFormsFormIdRouteRoute: typeof LayoutFeedbackFormsFormIdRouteRouteWithChildren
  LayoutFeedbackFormsHelpRouteRoute: typeof LayoutFeedbackFormsHelpRouteRoute
  LayoutFeedbackFormsNewRouteRoute: typeof LayoutFeedbackFormsNewRouteRoute
  LayoutFeedbackFormsIndexRoute: typeof LayoutFeedbackFormsIndexRoute
}

const LayoutFeedbackFormsRouteRouteChildren: LayoutFeedbackFormsRouteRouteChildren =
  {
    LayoutFeedbackFormsFormIdRouteRoute:
      LayoutFeedbackFormsFormIdRouteRouteWithChildren,
    LayoutFeedbackFormsHelpRouteRoute: LayoutFeedbackFormsHelpRouteRoute,
    LayoutFeedbackFormsNewRouteRoute: LayoutFeedbackFormsNewRouteRoute,
    LayoutFeedbackFormsIndexRoute: LayoutFeedbackFormsIndexRoute,
  }

const LayoutFeedbackFormsRouteRouteWithChildren =
  LayoutFeedbackFormsRouteRoute._addFileChildren(
    LayoutFeedbackFormsRouteRouteChildren,
  )

interface LayoutSpotOfTheWeekRouteRouteChildren {
  LayoutSpotOfTheWeekWeekIdRouteRoute: typeof LayoutSpotOfTheWeekWeekIdRouteRoute
  LayoutSpotOfTheWeekHelpRouteRoute: typeof LayoutSpotOfTheWeekHelpRouteRoute
  LayoutSpotOfTheWeekIndexRoute: typeof LayoutSpotOfTheWeekIndexRoute
}

const LayoutSpotOfTheWeekRouteRouteChildren: LayoutSpotOfTheWeekRouteRouteChildren =
  {
    LayoutSpotOfTheWeekWeekIdRouteRoute: LayoutSpotOfTheWeekWeekIdRouteRoute,
    LayoutSpotOfTheWeekHelpRouteRoute: LayoutSpotOfTheWeekHelpRouteRoute,
    LayoutSpotOfTheWeekIndexRoute: LayoutSpotOfTheWeekIndexRoute,
  }

const LayoutSpotOfTheWeekRouteRouteWithChildren =
  LayoutSpotOfTheWeekRouteRoute._addFileChildren(
    LayoutSpotOfTheWeekRouteRouteChildren,
  )

interface LayoutInsiderFeaturesRouteRouteChildren {
  LayoutInsiderFeaturesFlagIdRouteRoute: typeof LayoutInsiderFeaturesFlagIdRouteRoute
  LayoutInsiderFeaturesIndexRoute: typeof LayoutInsiderFeaturesIndexRoute
}

const LayoutInsiderFeaturesRouteRouteChildren: LayoutInsiderFeaturesRouteRouteChildren =
  {
    LayoutInsiderFeaturesFlagIdRouteRoute:
      LayoutInsiderFeaturesFlagIdRouteRoute,
    LayoutInsiderFeaturesIndexRoute: LayoutInsiderFeaturesIndexRoute,
  }

const LayoutInsiderFeaturesRouteRouteWithChildren =
  LayoutInsiderFeaturesRouteRoute._addFileChildren(
    LayoutInsiderFeaturesRouteRouteChildren,
  )

interface LayoutInsiderMembersRouteRouteChildren {
  LayoutInsiderMembersMemberIdRouteRoute: typeof LayoutInsiderMembersMemberIdRouteRoute
  LayoutInsiderMembersIndexRoute: typeof LayoutInsiderMembersIndexRoute
}

const LayoutInsiderMembersRouteRouteChildren: LayoutInsiderMembersRouteRouteChildren =
  {
    LayoutInsiderMembersMemberIdRouteRoute:
      LayoutInsiderMembersMemberIdRouteRoute,
    LayoutInsiderMembersIndexRoute: LayoutInsiderMembersIndexRoute,
  }

const LayoutInsiderMembersRouteRouteWithChildren =
  LayoutInsiderMembersRouteRoute._addFileChildren(
    LayoutInsiderMembersRouteRouteChildren,
  )

interface LayoutPloSolutionUploadGamemodesIdRouteRouteChildren {
  LayoutPloSolutionUploadGamemodesIdUploadRouteRoute: typeof LayoutPloSolutionUploadGamemodesIdUploadRouteRoute
  LayoutPloSolutionUploadGamemodesIdIndexRoute: typeof LayoutPloSolutionUploadGamemodesIdIndexRoute
}

const LayoutPloSolutionUploadGamemodesIdRouteRouteChildren: LayoutPloSolutionUploadGamemodesIdRouteRouteChildren =
  {
    LayoutPloSolutionUploadGamemodesIdUploadRouteRoute:
      LayoutPloSolutionUploadGamemodesIdUploadRouteRoute,
    LayoutPloSolutionUploadGamemodesIdIndexRoute:
      LayoutPloSolutionUploadGamemodesIdIndexRoute,
  }

const LayoutPloSolutionUploadGamemodesIdRouteRouteWithChildren =
  LayoutPloSolutionUploadGamemodesIdRouteRoute._addFileChildren(
    LayoutPloSolutionUploadGamemodesIdRouteRouteChildren,
  )

interface LayoutPloSolutionUploadGamemodesRouteRouteChildren {
  LayoutPloSolutionUploadGamemodesIdRouteRoute: typeof LayoutPloSolutionUploadGamemodesIdRouteRouteWithChildren
  LayoutPloSolutionUploadGamemodesIndexRoute: typeof LayoutPloSolutionUploadGamemodesIndexRoute
}

const LayoutPloSolutionUploadGamemodesRouteRouteChildren: LayoutPloSolutionUploadGamemodesRouteRouteChildren =
  {
    LayoutPloSolutionUploadGamemodesIdRouteRoute:
      LayoutPloSolutionUploadGamemodesIdRouteRouteWithChildren,
    LayoutPloSolutionUploadGamemodesIndexRoute:
      LayoutPloSolutionUploadGamemodesIndexRoute,
  }

const LayoutPloSolutionUploadGamemodesRouteRouteWithChildren =
  LayoutPloSolutionUploadGamemodesRouteRoute._addFileChildren(
    LayoutPloSolutionUploadGamemodesRouteRouteChildren,
  )

interface LayoutRouteChildren {
  LayoutAnalyzerInsightsRouteRoute: typeof LayoutAnalyzerInsightsRouteRouteWithChildren
  LayoutAnnouncementsRouteRoute: typeof LayoutAnnouncementsRouteRouteWithChildren
  LayoutBrevoRouteRoute: typeof LayoutBrevoRouteRouteWithChildren
  LayoutFeedbackFormsRouteRoute: typeof LayoutFeedbackFormsRouteRouteWithChildren
  LayoutSpotOfTheWeekRouteRoute: typeof LayoutSpotOfTheWeekRouteRouteWithChildren
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutInsiderFeaturesRouteRoute: typeof LayoutInsiderFeaturesRouteRouteWithChildren
  LayoutInsiderHelpRouteRoute: typeof LayoutInsiderHelpRouteRoute
  LayoutInsiderMembersRouteRoute: typeof LayoutInsiderMembersRouteRouteWithChildren
  LayoutPloSolutionUploadGamemodesRouteRoute: typeof LayoutPloSolutionUploadGamemodesRouteRouteWithChildren
  LayoutPloSolutionUploadGametypesRouteRoute: typeof LayoutPloSolutionUploadGametypesRouteRoute
  LayoutPloSolutionUploadHelpRouteRoute: typeof LayoutPloSolutionUploadHelpRouteRoute
  LayoutPloSolutionUploadUploadJobsRouteRoute: typeof LayoutPloSolutionUploadUploadJobsRouteRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAnalyzerInsightsRouteRoute:
    LayoutAnalyzerInsightsRouteRouteWithChildren,
  LayoutAnnouncementsRouteRoute: LayoutAnnouncementsRouteRouteWithChildren,
  LayoutBrevoRouteRoute: LayoutBrevoRouteRouteWithChildren,
  LayoutFeedbackFormsRouteRoute: LayoutFeedbackFormsRouteRouteWithChildren,
  LayoutSpotOfTheWeekRouteRoute: LayoutSpotOfTheWeekRouteRouteWithChildren,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutInsiderFeaturesRouteRoute: LayoutInsiderFeaturesRouteRouteWithChildren,
  LayoutInsiderHelpRouteRoute: LayoutInsiderHelpRouteRoute,
  LayoutInsiderMembersRouteRoute: LayoutInsiderMembersRouteRouteWithChildren,
  LayoutPloSolutionUploadGamemodesRouteRoute:
    LayoutPloSolutionUploadGamemodesRouteRouteWithChildren,
  LayoutPloSolutionUploadGametypesRouteRoute:
    LayoutPloSolutionUploadGametypesRouteRoute,
  LayoutPloSolutionUploadHelpRouteRoute: LayoutPloSolutionUploadHelpRouteRoute,
  LayoutPloSolutionUploadUploadJobsRouteRoute:
    LayoutPloSolutionUploadUploadJobsRouteRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

interface LoginRouteChildren {
  LoginOauthIndexRoute: typeof LoginOauthIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginOauthIndexRoute: LoginOauthIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
